module.exports = __webpack_public_path__ + "img/fashion_09.0eae4aaa.jpg";